import { FieldType } from './FieldType';

export const SlideType = {
    ARRIVAL: FieldType.ARRIVAL,
    DEPARTURE: FieldType.DEPARTURE,
    DATE: FieldType.DATE,
    PAX: FieldType.PAX,
    ROOM: FieldType.ROOM,
};
